import {Card} from "@/Components/Card";
import i18n from "i18next";
import ProfilePhotoManagement from "@/Components/Manage/ProfilePhotoManagement";
import {Inertia} from "@inertiajs/inertia";
import EditProfileModal from "@/Pages/Manage/EditProfileModal";

export default function ProfileInfoCard({props, state, dispatch}) {
    return (
        <Card dataTestid={'profile_info_card'} className="profile-info-card col">
            <div  className="profile-card-header">
                <span className="profile-card-title">{i18n.t("admin-account-overview.profile-info")}</span>
                <span data-testid="profile_info_card-link-edit_profile" className="edit-profile"
                    onClick={() => dispatch({ type: "editProfileModal", payload: { editProfileModal: true }})}
                >{i18n.t("admin-account-overview.edit-profile")}</span>
            </div>
            <div className="profile-card-body">
                <div>
                    <ProfilePhotoManagement
                        profileName={props.auth.user.first_name + " " + props.auth.user.last_name}
                        photoUrl={props.auth.user.avatars.lg}
                        onFileUploaded={data => {
                            // this endpoint needs to change;
                            // the following was taken directly from OrganizationLogoManagement
                            // and is not specific to uploading and changing the profile image

                            Inertia.post(
                                route('manage.organization.logo.store'),
                                data
                            )
                        }}
                    />
                </div>
                <div>
                    <div className="profile-information-container">
                        <div data-testid="admin_account_overview_name_subtitle-div" className="profile-info-subtitle">{i18n.t("admin-account-overview.name")}</div>
                        <div data-testid="admin_account_overview_name_information-div" className="profile-information">{props.auth.user.first_name + " " + props.auth.user.last_name}</div>
                    </div>
                    <div className="profile-information-container">
                        <div data-testid="admin_account_overview_email_address_subtitle-div" className="profile-info-subtitle">{i18n.t("admin-account-overview.email-address")}</div>
                        <div data-testid="admin_account_overview_email_address_information-div" className="profile-information">{props.auth.user.email}</div>
                    </div>
                    <div className="profile-information-container">
                        <div data-testid="admin_account_overview_phone_number_information-div" className="profile-info-subtitle">{i18n.t("admin-account-overview.phone-number")}</div>
                        <div data-testid="admin_account_overview_phone_number_information-div" className="profile-information">{props.auth.user.phone}</div>
                    </div>
                    <div className="profile-information-container">
                        <div data-testid="admin_account_overview_organization_information-div" className="profile-info-subtitle">{i18n.t("admin-account-overview.organization")}</div>
                        <div data-testid="admin_account_overview_organization_information-div" className="profile-information">{props.auth.current_organization.name}</div>
                    </div>
                </div>
            </div>
            { state.editProfileModal && <EditProfileModal props={props} state={state} dispatch={dispatch}/> }
        </Card>
    )
}
